import { LegalEntityDataDisplay } from "Components/UserAccount/Shared/Party/LegalEntityDataDisplay";
import { SelfEmployedDataDisplay } from "Components/UserAccount/Shared/Party/SelfEmployedDataDisplay";
import { VatNumberSection } from "Components/UserAccount/Shared/Party/VatNumberSection";
import { PartyType, type PartyDto } from "Infrastructure/Api/Api";

type Props = {
  party: PartyDto;
};

const PartyData = ({ party }: Props) => {
  if (party.type === PartyType.SelfEmployed) {
    return <SelfEmployedDataDisplay party={party} />;
  }

  return <LegalEntityDataDisplay party={party} />;
};

export const CompanyDataDisplay = ({ party }: Props) => (
  <>
    <PartyData party={party} />
    <VatNumberSection party={party} />
  </>
);
